import { userTokenKey } from '@disco/constants/environment'
import Storage from 'disco-storage'
import { useCallback } from 'react'
import { connect } from 'react-redux'
import type { User } from 'types/user'
import {
  autologinUser,
  logoutUser,
} from '@disco/state-management/actions/UserActions'
import useEventListener from 'hooks/use-event-listener'
import { useInterval } from 'hooks/use-interval'

const mapStateToProps = state => ({
  user: state.user,
})

type Props = {
  user: User
  autologinUser: typeof autologinUser
  logoutUser: typeof logoutUser
}

const SessionWatcher = ({ user, autologinUser, logoutUser }: Props) => {
  const handleStorageChange = useCallback(
    (e: StorageEvent) => {
      if (e.key !== userTokenKey) return

      if (e.newValue === null && user.loggedIn) {
        logoutUser()
      } else if (e.newValue && !user.loggedIn) {
        autologinUser()
      }
    },
    [user.loggedIn, logoutUser, autologinUser],
  )

  useEventListener('storage', handleStorageChange)
  return null
}

export default connect(mapStateToProps, {
  autologinUser,
  logoutUser,
})(SessionWatcher) as any
